export default __webpack_public_path__ + "static/media/heart.393fbfe0.svg";